import { type FC } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "flowbite-react";

interface PrivacyPolicyModalProps {
  show: boolean;
  onClose: () => void;
}

const PrivacyPolicyModal: FC<PrivacyPolicyModalProps> = ({ show, onClose }) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      size="xl"
      className="z-[10000]" // Higher z-index than signature pad (9999)
    >

      <ModalHeader>Datenschutzerklärung</ModalHeader>
      <ModalBody className="max-h-[70vh] overflow-y-auto">
        <div className="space-y-6">
          <h4 className="text-lg font-bold">
            Teleconnect24 GmbH – Einwilligungserklärung und Datenschutzhinweise
          </h4>

          <div>
            <h5 className="font-bold">Verantwortliche Stelle</h5>
            <p className="mt-2">
              <strong>Teleconnect24 GmbH</strong>
              <br />
              Branimir Milanović
              <br />
              Kolonnenstraße 8<br />
              10827 Berlin
              <br />
              E-Mail: verwaltung@teleconnect24.de
              <br />
              Umsatzsteuer-ID: DE 364500489
              <br />
              Handelsregister: Amtsgericht Charlottenburg, HRB 257292 B
            </p>
          </div>

          <div>
            <h5 className="font-bold">Datenschutzbeauftragter</h5>
            <p className="mt-2">
              Branimir Milanovic
              <br />
              E-Mail: verwaltung@teleconnect24.de
            </p>
          </div>

          <div>
            <h5 className="font-bold">Einwilligungserklärung</h5>
            <p className="mt-2">
              Die Teleconnect24 GmbH nimmt den Datenschutz sehr ernst. Wir
              nutzen Ihre Kontaktdaten (z. B. Name, Anschrift, E-Mail-Adresse,
              Telefonnummer), um Ihnen insbesondere Informationen und Angebote
              zu unseren Produkten (z. B. Strom, Gas, Internet) zur Verfügung zu
              stellen, Sie um Feedback zu bitten oder Ihnen allgemeine
              Informationen zu senden, die für Sie von Interesse sein könnten.
              Um Sie bestmöglich zu informieren, möchten wir Sie per E-Mail,
              Telefon, Social Media, Messenger, SMS oder Post kontaktieren.
            </p>
          </div>

          <div>
            <h5 className="font-bold">Hinweis zum Datenschutz</h5>
            <p className="mt-2">
              Sie können diese Einwilligung{" "}
              <strong>jederzeit mit Wirkung für die Zukunft</strong> widerrufen.
              Senden Sie dazu eine formlose Mitteilung per E-Mail an
              verwaltung@teleconnect24.de. Die Rechtmäßigkeit der bis zum
              Widerruf erfolgten Datenverarbeitung bleibt unberührt.
            </p>
            <p className="mt-2">
              Detaillierte Informationen zum Datenschutz finden Sie in unserer
              <a
                href="https://www.teleconnect24.de/datenschutz"
                className="ml-1 text-blue-600 underline hover:text-blue-800"
              >
                Datenschutzerklärung
              </a>
              .
            </p>
          </div>

          <div>
            <p className="mt-2">Ihnen stehen folgende Rechte zu:</p>
            <ul className="list-inside list-disc space-y-1 pl-4 pt-2">
              <li>
                <strong>Auskunft</strong> über Ihre gespeicherten Daten,
              </li>
              <li>
                <strong>Berichtigung</strong> unrichtiger Daten,
              </li>
              <li>
                <strong>Löschung</strong> Ihrer Daten, sofern keine gesetzlichen
                Aufbewahrungspflichten bestehen,
              </li>
              <li>
                <strong>Einschränkung</strong> der Verarbeitung Ihrer Daten,
              </li>
              <li>
                <strong>Datenübertragbarkeit</strong> (Erhalt Ihrer Daten in
                einem maschinenlesbaren Format),
              </li>
              <li>
                <strong>Beschwerderecht</strong> bei einer Aufsichtsbehörde (z.
                B. der zuständigen Datenschutzbehörde).
              </li>
            </ul>
          </div>

          <div>
            <p className="mt-2">
              Für Fragen zum Datenschutz oder zum Widerruf Ihrer Einwilligung
              kontaktieren Sie uns bitte unter:
              <br />
              <strong>Teleconnect24 GmbH</strong>
              <br />
              Kolonnenstraße 8<br />
              10827 Berlin
              <br />
              E-Mail: verwaltung@teleconnect24.de
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>Schließen</Button>
      </ModalFooter>
    </Modal>
  );
};

export default PrivacyPolicyModal;
